import React, { useState } from "react";
import Button from "../ui/Button";
import { useNavigate } from "react-router-dom";

const ProductCard = ({ product, index }) => {
  const [openSection, setOpenSection] = useState(null);

  const navigate = useNavigate(); // 2. Navigate function initialize karein

  // Click handler function
  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    } else {
      console.warn("Path define nahi kiya gaya hai!");
    }
  };

  return (
    <div className="w-full">
      {/* Product Image Container */}
      <div
        className={`relative w-full ${
          index < 12
            ? "bg-[linear-gradient(180deg,#ffedd9_0%,#fff9f3_100%)]"
            : "bg-[linear-gradient(153deg,#195939_0%,#031312_100%)]"
        } rounded-[15px] lg:rounded-[30px] p-[4px] md:p-[6px] lg:p-[8px] mb-[-120px] md:mb-[-180px] lg:mb-[-340px] z-10`}
      >
        <div className="flex justify-center items-center w-full">
          <img
            src={product?.image}
            alt={product?.title}
            className="w-[66%] h-[150px] md:h-[250px] lg:h-[442px] object-contain "
          />
        </div>
      </div>

      {/* Product Info Container */}
      <div className="bg-[linear-gradient(153deg,#195939_0%,#031312_100%)] rounded-[15px] lg:rounded-[30px] p-[10px] md:p-[15px] lg:p-[20px] pt-[120px] md:pt-[180px] lg:pt-[356px] relative z-0">
        <div className="flex flex-col items-center w-full">
          <h3 className="text-[20px] md:text-[30px] lg:text-[40px] font-[parkinsans] font-bold text-white">
            {product?.title}
          </h3>
          <p className="text-[12px] md:text-[16px] lg:text-[20px] font-[parkinsans] font-bold text-white opacity-80">
            {product?.subtitle}
          </p>
          <div className="hero-animated-item mt-[20px]">
            <Button
              text="Learn More"
              text_font_size="text-[16px] sm:text-[20px] xl:text-[24px]"
              text_font_family="Parkinsans"
              text_font_weight="font-semibold"
              text_line_height="leading-[23px] sm:leading-[28px] xl:leading-[34px]"
              text_text_align="center"
              text_color="#FFF"
              border_border="1px solid #FFF"
              border_border_radius="rounded-[50px]"
              layout_width="auto"
              padding="t=12px,r=32px,b=12px,l=32px"
              className=" transition-colors duration-300"
              onClick={() => handleNavigation(product?.path)}
            />
          </div>
          {/* <div className="w-full h-[1px] bg-white/30 mt-4 mb-2"></div> */}

          {/* About Section */}
          {/* <div className="flex flex-col w-full">
            <div
              className="flex justify-between items-center w-full cursor-pointer py-2"
              onClick={() => toggleSection("about")}
            >
              <span className="text-[14px] md:text-[18px] lg:text-[24px] font-semibold text-white">
                About
              </span>
              <span className="text-[14px] md:text-[18px] lg:text-[24px] font-bold text-white">
                {isOpenAbout ? "−" : "+"}
              </span>
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ${isOpenAbout ? "max-h-40 opacity-100 mb-4" : "max-h-0 opacity-0"}`}
            >
              <p className="text-[12px] md:text-[16px] lg:text-[20px] text-justify text-white/90">
                {product?.description}
              </p>
            </div>
          </div>

          Key Benefits Section
          <div className="flex flex-col w-full border-t border-white/30">
            <div
              className="flex justify-between items-center w-full cursor-pointer py-2"
              onClick={() => toggleSection("benefits")}
            >
              <span className="text-[14px] md:text-[18px] lg:text-[24px] font-semibold text-white">
                Key Benefits
              </span>
              <span className="text-[14px] md:text-[18px] lg:text-[24px] font-bold text-white">
                {isOpenBenefits ? "−" : "+"}
              </span>
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ${isOpenBenefits ? "max-h-40 opacity-100 mb-4" : "max-h-0 opacity-0"}`}
            >
              <p className="text-[12px] md:text-[16px] lg:text-[20px] text-justify text-white/90">
                {product?.benefits ||
                  "Information about benefits will be added here."}
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
